import styled from 'styled-components';

export const Root = styled.div`
  border: none;
  cursor: pointer;
  padding: 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-top: 1px solid ${({ theme }) => theme.colors.grey3};
`;

export const ActiveTitle = styled.div`
  font-weight: bold;
`;

export const InactiveTitle = styled.div`
  font-weight: normal;
`;
export const Image = styled.img`
  height: 20px;
  margin-right: 32px;
  width: 20px;
`;

export const TwoColumnGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 0fr);
  gap: 100;
`;
